import React from 'react';
import { useAuth } from '../../teal-react/utils/token';

const ExcludeReadOnly = ({ children }: { children: any }) => {
  const { user } = useAuth();
  if (user?.isRO) {
    return null;
  }
  return <>{children}</>;
};

export default ExcludeReadOnly;
